export default function getInputTypeDefinition({
  sourceActionId,
  sourceOutputName,
  actionOutputs
}) {
  const inputSource = actionOutputs.find(({
    actionId
  }) => actionId === sourceActionId);
  if (!inputSource) {
    return null;
  }
  const outputDefinition = inputSource.outputFieldDefinitions.find(({
    typeDefinition: {
      name
    }
  }) => name === sourceOutputName);
  return outputDefinition ? outputDefinition.typeDefinition : null;
}